import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import Error from 'next/error';

export default function RTKError({
  error,
}: {
  error: FetchBaseQueryError | SerializedError | undefined;
}) {
  if (!error) return null;

  if ('data' in error) {
    let fetchError = error as FetchBaseQueryError;

    const statusCode =
      typeof fetchError.status === 'string'
        ? 500
        : (fetchError.status as number);
    return <Error statusCode={statusCode} />;
  }

  return null;
}
